import"react";import e from"prop-types";var r={baseUrl:e.func,current:e.number,selectedPage:e.number,selectPage:e.func,total:e.number.isRequired,surface:e.oneOf(["light","dark"]),focusBorderRadius:e.string};export{r as default};
